
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import api from '~api'
export default {
name: "dormitoryInformation",
components: {
XHeader,Group,Selector,Confirm
},
data() {
return {
title: "宿舍信息",
list: '',
show: false,
stuinfo:{},
}
},
mounted(){
var _this = this
api.post("/api/NewReports/findInformation", {"stuCode": JSON.parse(this.$route.params.stuCode).stuCode}).then( res=>{

if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})

api.post("/orientation/selectDormInfo", {"stuCode": JSON.parse(this.$route.params.stuCode).stuCode}).then( response=>{

console.log(response)
if(response.status===200){
if(response.data.data!==null){
if(response.data.data.dormName!==null && response.data.data.dormno!==null){
_this.list = response.data.data;
}else {
_this.$msgbox('温馨提示：',"请等待分配宿舍");
_this.$router.replace({name: 'home'});
}
}else {
_this.$msgbox('温馨提示：',"请等待分配宿舍");
_this.$router.replace({name: 'home'});
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
},
methods:{
gotohome(){
var _this = this;
api.post("/api/stuEnter/add", {"stuCode": JSON.parse(this.$route.params.stuCode).stuCode}).then( res=>{
if(res.status==200){
if(res.data.code===0){
_this.$msgbox1('温馨提示：',res.data.msg);
_this.$router.push({name: 'scanCodes'});
}else {
_this.$msgbox('温馨提示：',res.data.msg);
}
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})

},
}
}



// WEBPACK FOOTER //
// ./src/components/dormitoryInformation.vue